module.exports = __webpack_public_path__ + "img/customer_profile_photo.39ebb4ef.jpg";